module.exports = __webpack_public_path__ + "static/media/pla_veh_pla_con.9a24ef03.png";